import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {htmlDecodeString} from '../../../shared/utils/htmlDecode';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-payment-page',
    templateUrl: './payment-page.component.html',
    styleUrls: ['./payment-page.component.scss']
})
export class PaymentPageComponent implements OnInit {
    checkoutId: string;
  payload: string;
  dataString: string;
  authData: any;
  paymentUrl: string;


  constructor(private route: ActivatedRoute, private http: HttpClient){
    this.extractQueryParams();
  }

  ngOnInit() {
    this.loadPaymentWidget();
  }

  extractQueryParams(){
    this.route.queryParams.subscribe(queryParams => {
      this.checkoutId = queryParams['checkoutId'];
      this.payload = queryParams['payload'];
      this.paymentUrl = `https://eu-prod.oppwa.com/v1/checkouts/${this.checkoutId}/payment`;
      if (this.payload) {
        this.dataString = JSON.parse(htmlDecodeString(atob(this.payload)));
      }
    });
  }

  loadPaymentWidget() {
    (window as any).wpwlOptions = {
      style: "logos",
      brandDetection: false,
      brandDetectionType: "regex",
      brandDetectionPriority: ["PRIVATE_LABEL", "VISA", "MAESTRO", "MASTER"],
      validateCard: function () {
        return true;
      },
      imageStyle: "svg",
      onReady: () => {
        this.hideBrands();
      },
      onChangeBrand: () => {
        this.hideBrands();
      }
    };


    const script = document.createElement('script');
    script.src = `https://eu-prod.oppwa.com/v1/paymentWidgets.js?checkoutId=${this.checkoutId}`;
    script.async = false;
    document.body.appendChild(script);
  }

  hideBrands() {
    const ready = (window as any).ready || false;
    const dotsClicked = (window as any).dotsClicked || false;
    if (!ready || dotsClicked) {
      return;
    }


    const logos = document.querySelectorAll('.wpwl-group-card-logos-horizontal > div');
    logos.forEach((logo: HTMLElement) => {
      logo.classList.remove("dots-hidden");
    });

    const nonHiddenLogos = document.querySelectorAll('.wpwl-group-card-logos-horizontal > div:not(.wpwl-hidden)');

    if (nonHiddenLogos.length < 2) {
      return;
    }

    const firstLogo = nonHiddenLogos[0] as HTMLElement;
    const dotsElement = document.createElement('div');
    dotsElement.textContent = '...';
    dotsElement.classList.add('dots');
    firstLogo.after(dotsElement);

    nonHiddenLogos.forEach((logo: HTMLElement, index: number) => {
      if (index > 0) {
        logo.classList.add("dots-hidden");
      }
    });

    dotsElement.addEventListener('click', () => {
      (window as any).dotsClicked = true;
      document.querySelectorAll('.dots-hidden').forEach((logo: HTMLElement) => {
        logo.classList.remove("dots-hidden");
      });
      dotsElement.remove();
    });
  }
}
